export const logger = {
  debug: (...args) => {
    // eslint-disable-next-line no-console
    console.debug('[DEBUG]', ...args);
  },
  info: (...args) => {
    // eslint-disable-next-line no-console
    console.info('[INFO]', ...args);
  },
  warn: (...args) => {
    // eslint-disable-next-line no-console
    console.warn('[WARN]', ...args);
  },
  error: (...args) => {
    // eslint-disable-next-line no-console
    console.error('[ERROR]', ...args);
  },
};

